import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import promoBannerService from "./promoBannerService";

const errMsg = (error) =>
  error.response?.data?.message || error.message || "Something went wrong";

export const fetchPromoBanner = createAsyncThunk(
  "promoBanner/fetch",
  async (_, thunkAPI) => {
    try {
      const res = await promoBannerService.get();
      return { data: res.data };
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || { message: errMsg(error) });
    }
  }
);

export const savePromoBanner = createAsyncThunk(
  "promoBanner/save",
  async (formData, thunkAPI) => {
    try {
      const res = await promoBannerService.save(formData);
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || { message: errMsg(error) });
    }
  }
);

const promoBannerSlice = createSlice({
  name: "promoBanner",
  initialState: {
    data: null,                                   // saved banner from the server (null = none yet)
    isLoading: false,                             // page load
    isSaving: false,                              // save
    isError: false,
    message: "",
    errors: {},                                   // field-wise validation errors
  },
  reducers: {
    clearPromoBannerError: (state) => {
      state.isError = false;
      state.message = "";
      state.errors = {};
    },
  },
  extraReducers: (builder) => {
    builder
      // fetch
      .addCase(fetchPromoBanner.pending, (s) => { s.isLoading = true; s.isError = false; })
      .addCase(fetchPromoBanner.fulfilled, (s, a) => {
        s.isLoading = false;
        s.data = a.payload.data;
      })
      .addCase(fetchPromoBanner.rejected, (s, a) => {
        s.isLoading = false;
        s.isError = true;
        s.message = a.payload?.message || "Failed to load promo banner";
      })
      // save
      .addCase(savePromoBanner.pending, (s) => { s.isSaving = true; s.isError = false; s.message = ""; s.errors = {}; })
      .addCase(savePromoBanner.fulfilled, (s, a) => { s.isSaving = false; s.data = a.payload; })
      .addCase(savePromoBanner.rejected, (s, a) => {
        s.isSaving = false;
        s.isError = true;
        s.message = a.payload?.message || "Save failed";
        s.errors = a.payload?.errors || {};
      });
  },
});

export const { clearPromoBannerError } = promoBannerSlice.actions;
export default promoBannerSlice.reducer;